import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { Settings } from '../../../core/settings';
import { Category } from '../../../documents';
import { Observable } from 'rxjs';
import { deserialize } from 'santee-dcts';
import { FilterItemsLoader } from '../../../documents/filter-items-loader';
import { DocumentFilterItemReadModel, DocumentFilterItem } from '../../../documents/document-filter-item';

@Injectable()
export class AdminDocumentsFilterItemsStorage implements FilterItemsLoader {
    private readonly apiPath = 'admin/documents-filter-items';

    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings
    ) { }

    public loadFilterItemsByCategory(category: Category, sponsorId$: Observable<string>): Observable<DocumentFilterItem[]> {
        return sponsorId$
            .pipe(
                switchMap(sponsorId => this.http.get(`${this.settings.apiUrl}/${this.apiPath}/${category.categoryId}${sponsorId ? `?sponsorId=${sponsorId}` : ''}`)),
                map((r) => deserialize(r, DocumentFilterItemReadModel).documentFilterItems)
            );
    }
}